import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Single shared MSAL instance so code outside the React tree (e.g. the
// Apollo error link) can trigger re-authentication without needing hooks.
export const msalInstance = new PublicClientApplication(
  msalConfig as Configuration
);
